export const OPEN_SERVICES_TOTAL_GET = "OPEN_SERVICES_TOTAL_GET";
export const SERVICES_BY_TYPE_AND_PLACE_GET = "SERVICES_BY_TYPE_GET";
export const AVERAGE_SERVICE_TIME_GET = "AVERAGE_SERVICE_TIME_GET";
